// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { EscalatorControllerInfoContent, unionToEscalatorControllerInfoContent, unionListToEscalatorControllerInfoContent } from './escalator-controller-info-content';
import { FirmwareVersionMessage, FirmwareVersionMessageT, verifyFirmwareVersionMessage } from './firmware-version-message';


export class EscalatorControllerInfoMessage implements flatbuffers.IUnpackableObject<EscalatorControllerInfoMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):EscalatorControllerInfoMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsEscalatorControllerInfoMessage(bb:flatbuffers.ByteBuffer, obj?:EscalatorControllerInfoMessage):EscalatorControllerInfoMessage {
  return (obj || new EscalatorControllerInfoMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsEscalatorControllerInfoMessage(bb:flatbuffers.ByteBuffer, obj?:EscalatorControllerInfoMessage):EscalatorControllerInfoMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new EscalatorControllerInfoMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

messageType():EscalatorControllerInfoContent {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : EscalatorControllerInfoContent.NONE;
}

message<T extends flatbuffers.Table>(obj:any):any|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
}

static startEscalatorControllerInfoMessage(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addMessageType(builder:flatbuffers.Builder, messageType:EscalatorControllerInfoContent) {
  builder.addFieldInt8(0, messageType, EscalatorControllerInfoContent.NONE);
}

static addMessage(builder:flatbuffers.Builder, messageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, messageOffset, 0);
}

static endEscalatorControllerInfoMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  builder.requiredField(offset, 6) // message
  return offset;
}

static createEscalatorControllerInfoMessage(builder:flatbuffers.Builder, messageType:EscalatorControllerInfoContent, messageOffset:flatbuffers.Offset):flatbuffers.Offset {
  EscalatorControllerInfoMessage.startEscalatorControllerInfoMessage(builder);
  EscalatorControllerInfoMessage.addMessageType(builder, messageType);
  EscalatorControllerInfoMessage.addMessage(builder, messageOffset);
  return EscalatorControllerInfoMessage.endEscalatorControllerInfoMessage(builder);
}

unpack(): EscalatorControllerInfoMessageT {
  return new EscalatorControllerInfoMessageT(
    this.messageType(),
    (() => {
      const temp = unionToEscalatorControllerInfoContent(this.messageType(), this.message.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })()
  );
}


unpackTo(_o: EscalatorControllerInfoMessageT): void {
  _o.messageType = this.messageType();
  _o.message = (() => {
      const temp = unionToEscalatorControllerInfoContent(this.messageType(), this.message.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })();
}



unpackFields(...fields: string[]): EscalatorControllerInfoMessageT {
  const t = new EscalatorControllerInfoMessageT();
  const fieldSet = new Set(fields);
  if (fieldSet.has('message_type')) {
    t.messageType = this.messageType();
  }
  if (fieldSet.has('message')) {
    t.message = (() => {
      const temp = unionToEscalatorControllerInfoContent(this.messageType(), this.message.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })();
  }
  return t;
}
}

export class EscalatorControllerInfoMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public messageType: EscalatorControllerInfoContent = EscalatorControllerInfoContent.NONE,
  public message: FirmwareVersionMessageT|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  if (this.message === null || this.message === undefined) {
    throw new Error('Required field "message" is not set');
  }
  const message = builder.createObjectOffset(this.message);

  return EscalatorControllerInfoMessage.createEscalatorControllerInfoMessage(builder,
    this.messageType,
    message
  );
}

clone(): EscalatorControllerInfoMessageT {
  const obj = new EscalatorControllerInfoMessageT();
  obj.messageType = this.messageType;
  obj.message = this.message !== null && typeof (this.message as any).clone === 'function' ? (this.message as any).clone() : this.message;
  return obj;
}

equals(other: EscalatorControllerInfoMessageT): boolean {
  if (this.messageType !== other.messageType) return false;
  if (this.message !== null && other.message !== null) {
    if (typeof (this.message as any).equals === 'function') {
      if (!(this.message as any).equals(other.message)) return false;
    } else if (this.message !== other.message) return false;
  } else if (this.message !== other.message) return false;
  return true;
}
}

export function verifyEscalatorControllerInfoMessage(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkUnionConsistency(tablePos, 4, 6, 'message');
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 4);
        switch (uType) {
          case 1: // FirmwareVersionMessage
            { const o = verifier.readInt32(pos); verifyFirmwareVersionMessage(verifier, pos + o); }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 6, 'message');
  } finally {
    verifier.popDepth();
  }
}
